export default "<layout-header></layout-header>\n<app-company-chooser></app-company-chooser>\n<router-outlet></router-outlet>\n"